import { R4 } from "@ahryman40k/ts-fhir-types";

import { ConfidentialityCode } from "@/global";

export type VaccinationResource =
  | R4.IImmunization
  | R4.IAllergyIntolerance
  | R4.ICondition
  | R4.IObservation;

export const vaccinationResourceTypes = [
  "Immunization",
  "AllergyIntolerance",
  "Condition",
  "Observation",
];

export interface Option {
  code: string;
  label: string;
  disabled?: boolean;
}

export interface NameForm {
  prefix: string;
  given: string;
  family: string;
}

export interface PractitionerRoleForm {
  practitionerName: NameForm;
  organizationName: string;
}

export interface ImmunizationFormModel {
  confidentialityCode: ConfidentialityCode;
  date: string;
  vaccineCode: string | null;
  targetDisease: string[];
  dose: number | null;
  lotNumber: string;
  performer: PractitionerRoleForm;
  notes: R4.IAnnotation[];
}

export interface AllergyIntoleranceFormModel {
  confidentialityCode: ConfidentialityCode;
  date: string;
  code: string;
  recorder: PractitionerRoleForm;
  notes: R4.IAnnotation[];
}

export interface InfectiousDiseaseFormModel {
  confidentialityCode: ConfidentialityCode;
  date: string;
  code: string;
  beginDate: string;
  endDate: string;
  recorder: PractitionerRoleForm;
  notes: R4.IAnnotation[];
}

export interface RiskFactorFormModel extends InfectiousDiseaseFormModel {
  clinicalStatus: "active" | "inactive";
}

export interface DocumentBundle extends R4.IBundle {
  entry: [R4.IBundle_Entry & { resource: R4.IComposition }, ...R4.IBundle_Entry[]];
}
